let lastTooltipShown: number | null = null

export function getLastTooltipTime(): number | null {
  return lastTooltipShown
}

export function updateLastTooltipTime(): void {
  lastTooltipShown = Date.now()
}
